export enum SupportedCountry {
    FRANCE = 'FR',
    BELGIUM = 'BE',
    NETHERLANDS = 'NL',
    GERMANY = 'DE',
    SPAIN = 'ES',
    UNITED_KINGDOM = 'UK',
    LUXEMBOURG = 'LU',
    UNITED_STATES = 'US',
}